import { useEffect, useMemo, useState } from 'react';
import { ButtonGroup, ArrowBackwardIcon, ArrowForwardIcon } from '@arnold/common';
import History from 'rete-history-plugin/_types/history';
import { HistoryAction } from 'rete-history-plugin';
import { CustomNodeEditor } from '../rete';

export const UndoRedoButtons = ({ editor }: { editor: CustomNodeEditor }) => {
  const [undoAvailable, setUndoAvailable] = useState(false);
  const [redoAvailable, setRedoAvailable] = useState(false);

  const updateUndoRedoAvailability = useMemo(
    () => () => {
      const history: History<HistoryAction> = (editor.historyPlugin as any).history;
      setUndoAvailable(!!history.produced.length);
      setRedoAvailable(!!history.reserved.length);
    },
    [editor],
  );

  useEffect(() => {
    editor.addHistoryChangeListener(updateUndoRedoAvailability);

    return () => {
      editor.removeHistoryChangeListener(updateUndoRedoAvailability);
    };
  }, [editor, updateUndoRedoAvailability]);

  return (
    <ButtonGroup
      buttonGroupItems={[
        {
          item: <ArrowBackwardIcon />,
          onClick: () => {
            void editor?.performUndo().then(updateUndoRedoAvailability);
          },
          disabled: !undoAvailable,
          color: 'highlighted',
          dataIcom: 'btn-undo-ariel',
        },
        {
          item: <ArrowForwardIcon />,
          onClick: () => {
            void editor?.performRedo().then(updateUndoRedoAvailability);
          },
          disabled: !redoAvailable,
          color: 'highlighted',
          dataIcom: 'btn-redo-ariel',
        },
      ]}
    />
  );
};
